import React, { useState, useEffect } from 'react';
import Jobs_header from '../Header/Jobs_header';
import back_arrow from "../../assets/svg/back-arrow.svg";
import { useNavigate, useLocation } from "react-router-dom";
import "../../styles/Jobs.css";
import small_line from "../../assets/svg/small_line.svg";
import download_arrow from "../../assets/svg/download_arrow.svg";
import { ToastContainer } from 'react-toastify';
import axios from 'axios';
import axiosInstance from '../../axiosInstance';
import CommonFooter from '../../CommonFooter/CommonFooter';

const GenerateSalesViewPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;
    const [jobData, setJobData] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [allCategories, setAllCategories] = useState([]);

    // If job data is passed via state, use it directly
    const initialJob = state?.job || {};
    const jobId = initialJob.id || initialJob.job_id;
    const [selectedRows, setSelectedRows] = useState([]);

    useEffect(() => {
        const fetchJobDetails = async () => {
            if (!jobId) {
                setIsLoading(false);
                return;
            }

            try {
                setIsLoading(true);

                // const response = await axios.get(
                //     `https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/job/edit/${jobId}`
                // );

                const response = await axiosInstance.get(
                    `/job/edit/${jobId}`
                );

                if (response.data && response.data.success) {
                    console.log("Job Data:", response.data.data);
                    const job = response.data.data;
                    setJobData(job);
                    const salesLines = job.sales_lines || [];
                    // Transform the data to match your category structure

                    const salesRows = salesLines.map(line => ({
                        joblineId: line.id,
                        chargecode: line.charge_code,
                        description: line.description_of_charges,
                        salesunitQuantity: parseFloat(line.unit_of_quantity) || 0,
                        salesRemarks: line.remarks || "",
                        salesRate: parseFloat(line.unit_of_rate) || 0,
                        salesNetTotal: parseFloat(line.net_total) || 0,
                        salesAccrual: parseFloat(line.accrual) || 0,
                        salesAttachmentUrl: line.attachment_url || null,
                        salesStatus: line.sales_status || null,
                        salesContractValue: parseFloat(line.contract_value) || 0,
                        salesInvStatus: line.sales_invoice_status || "",
                        po_wo_number: line.po_wo_number || "",
                        po_wo_date: line.po_wo_date || ""
                    }));

                    // Category totals
                    const salesNetTotal = salesRows.reduce((sum, row) => sum + row.salesNetTotal, 0);
                    const salesAccrual = salesRows.reduce((sum, row) => sum + row.salesAccrual, 0);

                    const transformedCategory = {
                        id: job.job_id,
                        jobnumber: job.job_no,
                        salesRows,
                        salesNetTotal,
                        salesAccrual,

                    };

                    setAllCategories([transformedCategory]);
                } else {
                    // Fall back to the initial job data if available
                    if (Object.keys(initialJob).length > 0) {
                        setJobData(initialJob);
                        const transformedCategory = {
                            id: initialJob.id,
                            jobnumber: initialJob.job_no,
                            salesRows: [],
                        };
                        setAllCategories([transformedCategory]);
                    }
                }
            } catch (err) {
                console.error("Error fetching job details:", err);
                // Fall back to the initial job data if available
                if (Object.keys(initialJob).length > 0) {
                    setJobData(initialJob);
                    const transformedCategory = {
                        id: initialJob.id,
                        jobnumber: initialJob.job_no,
                        salesRows: [],
                    };
                    setAllCategories([transformedCategory]);
                }
            } finally {
                setIsLoading(false);
            }
        };

        fetchJobDetails();
    }, [jobId, initialJob]);


    const calculateCategoryTotals = (category) => {
        const salesTotals = category.salesRows.reduce((totals, row) => {
            return {
                quantity: totals.quantity + (parseFloat(row.salesunitQuantity) || 0),
                rate: totals.rate + (parseFloat(row.salesRate) || 0),
                netValue: totals.netValue + (parseFloat(row.salesNetTotal) || 0),
                accrual: totals.accrual + (parseFloat(row.salesAccrual) || 0)
            };
        }, { quantity: 0, rate: 0, netValue: 0, accrual: 0 });
        return {
            sales: salesTotals,
        }
    };

    const handleDownload = (attachmentUrl) => {
        // Implement your download logic here
        console.log("Downloading:", attachmentUrl);
        // You can use window.open(attachmentUrl) or implement a proper download
        window.open(attachmentUrl, '_blank');
    };

    if (isLoading) {
        return (
            <>
                <Jobs_header />
                <div className="jobs_module">
                    <div className="loading-container">
                        <p>Loading job details...</p>
                    </div>
                </div>
            </>
        );
    }

    // Handle individual row checkbox change
    const handleRowCheckboxChange = (rowIndex, isChecked) => {
        if (isChecked) {
            setSelectedRows(prev => [...prev, rowIndex]);
        } else {
            setSelectedRows(prev => prev.filter(index => index !== rowIndex));
        }
    };

    // Handle "select all" checkbox change
    const handleSelectAllChange = (e) => {
        if (e.target.checked) {
            // Select all rows
            const allRowIndices = allCategories.flatMap(category =>
                category.rows.map((_, index) => index)
            );
            setSelectedRows(allRowIndices);
        } else {
            // Deselect all
            setSelectedRows([]);
        }
    };



    return (
        <>
            <Jobs_header onSearch={null} disableSearch={true} />
            <div className='jobs_module'>
                <div className="jobs-module-header">
                    <div className="jobs-module-header-left">
                        <img
                            src={back_arrow}
                            alt="Back Arrow"
                            onClick={() => navigate(-1)}
                            style={{ cursor: "pointer" }}
                        />
                        <p className="new_job">{jobData.job_no || jobData.job_number || 'N/A'}</p>
                    </div>
                </div>

                <div className='jobs-module-details'>
                    <div className='jobs-module-job-details'>
                        <p className='jobs-module-jobs-details-header'>Job details</p>
                        <div className='jobs-module-details-grid'>
                            <p className='jobs-module-jobs-details-label'>Job No</p>
                            <p className='jobs-module-jobs-details-value'>{jobData.job_no || jobData.job_number || 'N/A'}</p>

                            <p className='jobs-module-jobs-details-label'>Project</p>
                            <p className='jobs-module-jobs-details-value'>{jobData.project_name || jobData.project || 'N/A'}</p>

                            <p className='jobs-module-jobs-details-label'>Date</p>
                            <p className='jobs-module-jobs-details-value'>
                                {jobData.date ? new Date(jobData.date).toLocaleDateString() : 'N/A'}
                            </p>

                            <p className='jobs-module-jobs-details-label'>Status</p>
                            <p className='jobs-module-jobs-details-value'>
                                <span className={`status-badge ${jobData.status || jobData.approval_status}`}>
                                    {jobData.status || jobData.approval_status}
                                </span>
                            </p>

                            <p className='jobs-module-jobs-details-label'>Created Date</p>
                            <p className='jobs-module-jobs-details-value'>
                                {jobData.created_date ? new Date(jobData.created_date).toLocaleDateString() : 'N/A'}
                            </p>

                            <p className='jobs-module-jobs-details-label'>Sales Accrual</p>
                            <p className='jobs-module-jobs-details-value'>
                                {Number(jobData.total_sales_accrual).toFixed(2)}
                            </p>

                            <p className='jobs-module-jobs-details-label'>Supply Period</p>
                            <p className='jobs-module-jobs-details-value'>
                                {jobData.supply_period}
                            </p>

                            {jobData.division_type === "ff" && (
                                <>
                                    <p className='jobs-module-jobs-details-label'>Plant Code</p>
                                    <p className='jobs-module-jobs-details-value'>
                                        {jobData.ff_plant_code || 'N/A'}
                                    </p>
                                </>
                            )}

                        </div>
                    </div>

                    <div className='jobs-module-job-types'>
                        <div className='job-types-content'>
                            <p className='jobs-module-jobs-details-header'>Job types</p>
                            <div className='job-types-buttons'>
                                {jobData.sales_lines?.length > 0 ? (
                                    [...new Set(jobData.sales_lines.map(line => line.job_type_name))].map((type, index) => (
                                        <button key={index} className='jobs-module-jobs-details-data'>
                                            {type || 'N/A'}
                                        </button>
                                    ))
                                ) : (
                                    <button className='jobs-module-jobs-details-data'>N/A</button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="invoice_popup_categories" style={{ marginTop: '10px' }}>
                    {/* <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontFamily: 'Work Sans' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <p className="invoice-module-summary-summary">Select jobs to generate Sales bill</p>
                                {selectedRows.length > 0 && (
                                    <span style={{ 
                                    fontSize: '12px',
                                    color: '#555',
                                    backgroundColor: '#f0f0f0',
                                    padding: '5px 10px',
                                    borderRadius: '10px',
                                    fontFamily: 'Work Sans',
                                    }}>
                                    {selectedRows.length} Selected
                                    </span>
                                )}
                                </div>
                                {selectedRows.length > 0 && (
                                <div style={{ display: 'flex', gap: '10px' }}>
                                    <button
                                    style={{
                                        backgroundColor: '#20824A',
                                        color: 'white',
                                        border: 'none',
                                        padding: '8px 16px',
                                        borderRadius: '12px',
                                        cursor: 'pointer',
                                        height:'37px',
                                        fontWeight:'600',
                                        fontSize:'12px'
                                    }}
                                    >
                                    Generate Sales Invoice
                                    </button>
                                </div>
                                )}
                            </div> */}

                    {allCategories.map((category, index) => {
                        const totals = calculateCategoryTotals(category);
                        return (
                            <div key={index} className="invoice_popup_outercategory">
                                <div className="invoice_popup_category_header">
                                    <div className="category_name_left" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        {/* <input type="checkbox" /> */}
                                        <span className="category_name">Job Type</span>
                                    </div>

                                    {/* 
                                    <div className="category_name_left">
                                        <span className="category_name_accrual">
                                            Accrual : <span className="number_highlight">{Number(jobData.accrual).toFixed(2)}</span>
                                        </span>
                                    </div> */}
                                    <div style={{
                                        display: "flex",
                                        gap: "12px",
                                        fontSize: '12px',
                                        flexWrap: "wrap"
                                    }}>
                                        {/* SALES BOX */}
                                        <div style={{
                                            backgroundColor: "#ffffff",
                                            borderRadius: "8px",
                                            padding: "12px 16px",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "8px",
                                            width: 'auto',
                                            height: '30px',
                                            boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                                        }}>
                                            <span style={{ color: "green", fontWeight: "600" }}>SALES : </span>
                                            <span style={{ color: "#000" }}>Accrual : ₹ {category.salesAccrual?.toLocaleString()}</span>
                                            <span style={{
                                                width: "1px",
                                                backgroundColor: "#ccc",
                                                alignSelf: "stretch"
                                            }}></span>
                                            <span style={{ color: "#000" }}>Net Total : ₹ {category.salesNetTotal?.toLocaleString()}</span>
                                        </div>

                                        {/* <div style={{
                                            width: "1px",
                                            backgroundColor: "#ccc",
                                            alignSelf: "stretch"
                                        }} />

                                        <div style={{
                                            width: "1px",
                                            backgroundColor: "#ccc",
                                            alignSelf: "stretch"
                                        }} />

                                            <div style={{
                                            backgroundColor: "#ffffff",
                                            borderRadius: "8px",
                                            padding: "12px 16px",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "8px",
                                            width:'auto',
                                            height:'30px',
                                            boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                                            }}>
                                            <span style={{ color: "purple", fontWeight: "600" }}>PROFIT : </span>
                                            <span style={{ color: "#000" }}>Amount : ₹{category.profitAmount?.toLocaleString()}</span>
                                            <span style={{ color: "purple", fontWeight: "600" }}>PROFIT % :</span>
                                            <span style={{ color: "#000" }}>{category.profitPercent?.toLocaleString()}%</span>
                                        </div> */}
                                    </div>
                                    {/* 
                                    <div className="category_name_right">
                                        <span className="category_name_quantity">
                                            Quantity : <span className="number_highlight">{totals.quantity.toFixed(2)}</span>
                                        </span>
                                        <img src={small_line} alt="" />
                                        <span className="category_name_rate">
                                            Rate : <span className="number_highlight">{totals.rate.toFixed(2)}</span>
                                        </span>
                                        <img src={small_line} alt="" />
                                        <span className="category_name_netvalue">
                                            Net Value : <span className="number_highlight">{totals.netValue.toFixed(2)}</span>
                                        </span>
                                    </div> */}
                                </div>

                                <div className="invoice_popup_category_subheader">
                                    <div className="invoice_popup_element_list" style={{ overflowX: "auto" }}>
                                        <div className="table-container">
                                            <table className="invoice_table">
                                                <thead>
                                                    <tr>
                                                        {/* <th rowSpan="2">
                                                        <input
                                                            type="checkbox"
                                                            style={{
                                                            width: "14px",
                                                            height: "14px",
                                                            borderRadius: "2px",
                                                            }}
                                                            checked={selectedRows.length === allCategories.flatMap(cat => cat.rows).length}
                                                            onChange={handleSelectAllChange}
                                                        />
                                                        </th> */}

                                                        <th colSpan="12" style={{ backgroundColor: '#D9FFE2', padding: '10px', color: '#008B1F' }}>SALES</th>
                                                    </tr>
                                                    <tr>
                                                        <th style={{ backgroundColor: '#D9FFE2' }}>CHARGE CODE</th>
                                                        <th style={{ backgroundColor: '#D9FFE2' }}>DESCRIPTION</th>
                                                        <th style={{ backgroundColor: '#D9FFE2' }}>PO/WO NO</th>
                                                        <th style={{ backgroundColor: '#D9FFE2' }}>PO/WO Date</th>
                                                        <th style={{ padding: '10px', backgroundColor: '#D9FFE2' }}>REMARKS</th>
                                                        <th style={{ backgroundColor: '#D9FFE2' }}>ACCRUAL SPLIT</th>
                                                        <th style={{ backgroundColor: '#D9FFE2' }}>CONTRACT VALUE</th>
                                                        <th style={{ backgroundColor: '#D9FFE2' }}>QUANTITY</th>
                                                        <th style={{ backgroundColor: '#D9FFE2' }}>RATE</th>
                                                        <th style={{ backgroundColor: '#D9FFE2' }}>NET TOTAL</th>
                                                        <th style={{ backgroundColor: '#D9FFE2' }}>ATTACHMENT</th>
                                                        <th style={{ backgroundColor: '#D9FFE2' }}>INV STATUS</th>
                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    {category.salesRows.map((row, rowIndex) => (
                                                        <tr key={rowIndex}>
                                                            {/* <td><input
                                                                    type="checkbox"
                                                                    checked={selectedRows.includes(rowIndex)}
                                                                    onChange={(e) => handleRowCheckboxChange(rowIndex, e.target.checked)}
                                                                /> 
                                                                </td> */}
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    style={{ margin: '0px', fontSize: '13px', fontFamily: 'Work Sans' }}
                                                                    value={row.chargecode}
                                                                    className="invoice_small_input"
                                                                    readOnly
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    style={{ margin: '0px', fontSize: '12px', fontFamily: 'Work Sans' }}
                                                                    value={row.description}
                                                                    className="invoice_small_input"
                                                                    readOnly
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    style={{ margin: '0px', fontSize: '12px', fontFamily: 'Work Sans' }}
                                                                    value={row.po_wo_number}
                                                                    className="invoice_small_input"
                                                                    readOnly
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    style={{ margin: '0px', fontSize: '12px', fontFamily: 'Work Sans' }}
                                                                    value={row.po_wo_date}
                                                                    className="invoice_small_input"
                                                                    readOnly
                                                                />
                                                            </td>
                                                            {/* <td>{row.accrualSplit || '0.00'}</td> */}
                                                            {/* <td>
                                                                    <input
                                                                        type="text"
                                                                        style={{ margin: '0px', fontSize: '12px', fontFamily: 'Work Sans' }}
                                                                        value={row.unitQuantity}
                                                                        className="invoice_small_input"
                                                                        readOnly />
                                                                </td> */}
                                                            {/* <td>{row.unitRatePrice || '0.00'}</td>
                                                                <td>{row.netTotal || '0.00'}</td> */}
                                                            {/* SALES REMARKS */}
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    value={row.salesRemarks}
                                                                    className="contracts_small_input"
                                                                    style={{ margin: '0px', fontFamily: 'Work Sans' }}
                                                                    readOnly
                                                                />
                                                            </td>

                                                            {/* SALES accrualSplit */}
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    value={row.salesAccrual}
                                                                    className="invoice_narrow_input"
                                                                    style={{ margin: '0px', fontFamily: 'Work Sans' }}
                                                                    readOnly
                                                                />
                                                            </td>
                                                            {/* SALES RATE */}
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    style={{ margin: '0px', fontSize: '12px', fontFamily: 'Work Sans' }}
                                                                    value={row.salesContractValue}
                                                                    className="invoice_narrow_input"
                                                                    readOnly />
                                                            </td>
                                                            {/* SALES QUANTITY */}
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    style={{ margin: '0px', fontSize: '12px', fontFamily: 'Work Sans' }}
                                                                    value={row.salesunitQuantity}
                                                                    className="invoice_narrow_input_quantity"
                                                                    readOnly />
                                                            </td>
                                                            {/* SALES RATE */}
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    value={row.salesRate}
                                                                    className="invoice_narrow_input"
                                                                    readOnly
                                                                    style={{ margin: '0px', fontFamily: 'Work Sans' }}
                                                                />
                                                            </td>
                                                            {/* SALES NET TOTAL */}
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    value={row.salesNetTotal}
                                                                    readOnly
                                                                    className="invoice_narrow_input"
                                                                    style={{ margin: '0px', fontFamily: 'Work Sans' }}

                                                                />
                                                            </td>
                                                            {/* SALES  ATTACHMENT*/}
                                                            <td>
                                                                {row.salesAttachmentUrl && (
                                                                    <div className="file_upload_wrapper">
                                                                        <div className="download_file_item">
                                                                            <button
                                                                                onClick={() => handleDownload(row.salesAttachmentUrl)}
                                                                                className="download_btn"
                                                                            >
                                                                                <img src={download_arrow} alt="Download" className="file_icon" />
                                                                                <span className="download_text">Download</span>
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </td>
                                                            {/* SALES INVOICE STATUS */}
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    value={row.salesInvStatus}
                                                                    className="contracts_small_input"
                                                                    style={{ margin: '0px', fontFamily: 'Work Sans' }}
                                                                    readOnly
                                                                />
                                                            </td>

                                                        </tr>
                                                    ))
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
            <CommonFooter />
            <ToastContainer position="top-right" autoClose={2000} hideProgressBar={false} />
        </>
    );
};

export default GenerateSalesViewPage
